import RecentLineup from "../RecentLineup";
import HeadToHead from "../HeadToHead";
import CompareStrength from "../CompareStrength";
export default function HeadToHeadTab() {
  
  return (
    <div className="space-y-4 text-[var(--theme-text)] bg-[var(--theme-bg)]">
      <CompareStrength />
      <HeadToHead />
      <RecentLineup />
    </div>
  );
}
